import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const companyRoutesDictionary = moduleRouteDictionaryFactory(
  'company',
  'companies',
  {
    list: 'list',
    create: 'create',
    createLegacy: 'create-legacy',
    update: 'update/:id',
    setCreditLimits: 'set-credit-limits/:companyId',
    detail: 'detail/:id',
    chooseCompanyCreditTypes: 'choose-credit-types/:id',
    chooseCompanyCardType: 'choose-card-type/:id',
    editFinancialInfo: 'edit-financial-info/:id',
    createFinancialInfo: 'create-financial-info/:id',
    editWelfarePlan: 'edit-welfare-plan/:id',
    chooseFlexibleBenefits: 'choose-flexible-benefits/:id',
  },
);
